import { render } from "./ProjectSelectComponent.vue?vue&type=template&id=915d2df6"
import script from "./ProjectSelectComponent.vue?vue&type=script&lang=js"
export * from "./ProjectSelectComponent.vue?vue&type=script&lang=js"

import "./ProjectSelectComponent.vue?vue&type=style&index=0&id=915d2df6&lang=css"

import exportComponent from "C:\\repo\\dashboard-project-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__